// extracted by mini-css-extract-plugin
export default {"block":"en","crumb":"fn","monochrome":"gn"};